import React from 'react';
import useJumboApp from "@jumbo/hooks/useJumboApp";
import { config } from "../../../app/config/main";
import appConfig from 'app/config/appConfig';

const Page = ({ component, layout, isWebview = false, ...restProps }) => {
  const { activeLayout, setActiveLayout } = useJumboApp();

  React.useEffect(() => {
    if (isWebview && appConfig.debugMode === 0) {
      /* PREVENT INSPECT */
      document.addEventListener('contextmenu', (e) => e.preventDefault());

      function ctrlShiftKey(e, keyCode) {
        return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
      }

      document.onkeydown = (e) => {
        // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
        if (
          e.keyCode === 123 ||
          ctrlShiftKey(e, 'I') ||
          ctrlShiftKey(e, 'J') ||
          ctrlShiftKey(e, 'C') ||
          (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
        )
          return false;
      };
    }
    if (layout !== activeLayout) {
      setActiveLayout(layout);
    }
  }, [layout, setActiveLayout, activeLayout]);

  const PageComponent = component;

  if (layout !== activeLayout) {
    return null;
  }

  return (
    <PageComponent {...restProps} />
  );
};

Page.defaultProps = {
  layout: config.defaultLayout
};

export default Page;